// Mirrors the backend ProtocolConsumptionRealizeTypeEnum.
// NOTE: this is NOT the same scale as VisitTypeEnum (which is 0-based and maps
// 2 to HOME_VISIT). This one is 1-based and applies to `realizedType`.
export enum ProtocolConsumptionRealizeTypeEnum {
  RealizedRemotely = 1,
  RealizedFaceToFace = 2,
  RealizedAtHome = 3,
  NotRealized = 4,
}
